import React, { useEffect, useState, useRef } from 'react';
import { BackToKdealerLogin, RemoveCookie, days, user_session_id, GetDomain, GetCoockie, IsKDealerWebsite, IskCountryWebsite, IsLocalHost, GetRedirectHost } from '../GlobalScript'
import Cookies from 'js-cookie';
import { useTranslation } from 'react-i18next';
import { useNavigate } from "react-router-dom";
import Container from 'react-bootstrap/Container';
import Card from 'react-bootstrap/Card';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import FloatingLabel from 'react-bootstrap/FloatingLabel';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import FooterSmall from '../FooterSmall';

export default function Login() {
    const navigate = useNavigate();
    const { t } = useTranslation();
    const [UserInfo, setUserInfo] = useState(null);
    const [login, setLogin] = useState(false);
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [Loading, setLoading] = useState(true);
    const [LoginError, setLoginError] = useState('');
    const [popUpModal, setPopUpModal] = useState(false);
    const [kDeal, setKDeal] = useState(true);
    const [headText, setHeadText] = useState('K-DEALER');

    useEffect(() => {        
        if (window.location.origin.indexOf("kdealer") > -1 || window.location.origin.indexOf("k-dealer") > -1) {
            document.title = 'K-Dealer - Login';
        } else if (window.location.origin.indexOf("kcountries") > -1 || window.location.origin.indexOf("k-countries") > -1) {
            document.title = 'K-Countries - Login';
            setHeadText('K-COUNTRIES');
        } else if (window.location.origin.indexOf("localhost") > -1) {
            document.title = 'K-Dealer - Login';
        } else {
            navigate("/sessionexpired");
        }

        /*handleRedirect();*/
    }, []);

    const handleChange = (event) => {
        const { name, value } = event.target;
        if (name === 'email') {
            setEmail(value);
        } else if (name === 'password') {
            setPassword(value);
        }
    };

    const handlePopUpModalShow = () => {
        setPopUpModal(true);
    }

    const handlePopUpModalClose = () => {
        setPopUpModal(false);
    }

    const handleRedirect = () => {
        /*const redirect = Cookies.get('redirect');*/
        console.log("inside redirect");
        //show popup
        if (window.location.origin.indexOf("kdealer") > -1 || window.location.origin.indexOf("k-dealer") > -1) {
            //show that they're being redirected to k-dealer
            setKDeal(true);
            handlePopUpModalShow();
        } else if (window.location.origin.indexOf("kcountries") > -1 || window.location.origin.indexOf("k-countries") > -1) {
            //show that they're being redirected to k-country
            setKDeal(false);
            handlePopUpModalShow();
        }
        /*Cookies.remove("redirect");*/        
    }

    //const setRedirectCookie = () => {
    //    let domain = GetDomain();
    //    if (domain === '') {
    //        Cookies.set('redirect', "1", { expires: days });
    //    } else {
    //        Cookies.set('redirect', "1", { expires: days, domain: domain, secure: true });
    //    }
    //}

    const signin = async () => {
        if (!email || !password || email.trim() === '' || password === '') {
            return;
        }

        try {
            const requestOptions = {
                method: 'POST',
                headers: {
                    'Content-type': 'application/json'
                },
                body: JSON.stringify({ label: email, value: password })
            };

            const res = await fetch('kdealer/SignIn', requestOptions);

            if (res.status !== 200) {
                const msg = "Incorrect email or password.";
                setLoginError(msg);
                throw new Error(msg);
            }
            const usrSession = await res.json();

            const userObj = {
                'firstName': usrSession.firstName,
                'lastName': usrSession.lastName,
                'email': usrSession.email,
                'dealerKey': usrSession.dealerKey,
                'userKey': usrSession.userKey,
                'dealerName': usrSession.dealerName,
                'dealerID': usrSession.dealerID,
                'loginType': usrSession.loginType,
                'region': usrSession.region,
                'address': usrSession.address,
                'loading': 0,
                'buyerCookie': usrSession.buyerCookie
            };

            let domain = GetDomain();
            console.log('domain: ' + domain);
            if (domain === '') {
                Cookies.set('user', JSON.stringify(userObj), { expires: days });
            } else {
                Cookies.set('user', JSON.stringify(userObj), { expires: days, domain: domain, secure: true });
            }
            setUserInfo({
                'firstName': usrSession.firstName,
                'lastName': usrSession.lastName,
                'email': usrSession.email,
                'dealerKey': usrSession.dealerKey,
                'userKey': usrSession.userKey,
                'loginType': usrSession.loginType,
                'kmcst': usrSession.KMCST,
                'dealerID': usrSession.dealerID,
                'rdmString': 'testtest',
                'buyerCookie': usrSession.buyerCookie
            });

            localStorage.removeItem('shoppingcart');
            localStorage.removeItem("orderSearch");
            localStorage.removeItem("creditSearch");

            window.GlobalLoading = 0;
            console.log('cookie: ' + GetCoockie());
            //if (usrSession.loginType === 1) {
            //    navigate('/dealerhome');
            //} else if (usrSession.loginType === 5) {
            //    navigate('/kcountrieshome');
            //}   
            //LogoutDealerClick();
            
            const local = IsLocalHost();
            if (usrSession.loginType === 1) {
                const kdealer = IsKDealerWebsite();
                if (kdealer === true || local === true) {
                    navigate('/dealerhome');
                } else {
                    /*setRedirectCookie();*/
                    handleRedirect();
                }
            } else if (usrSession.loginType === 5) {
                const kctry = IskCountryWebsite();
                if (kctry === true || local === true) {
                    navigate('/kcountrieshome');
                } else {
                    /*setRedirectCookie();*/
                    handleRedirect();
                }
            } else {
                navigate('/login');
            }          
        } catch (e) {

        }        
    }

    const LogoutDealerClick = () => {
        debugger;
        RemoveCookie(days, user_session_id);
        const host = GetRedirectHost();
        console.log(host + '/login');
        window.location.replace(host + '/login');
        setUserInfo(null);
    }

    const handleSignin = (e) => {
        e.preventDefault();
        signin();
    };

    useEffect(() => {
        if (Loading) {
            debugger;
            console.log(window.location.href);
            RemoveCookie(days, user_session_id);
            setLoading(false);
        }
    }, [Loading])

    return (
        <>
            <div className="login-bg"></div>
            <Container className="main-container">
                <Row className="margin-vertical">

                    <Col lg={5} className="login-card card">
                        <Row className="green-border-bottom black-bg">
                            <Col sm={12}>
                                <h1>{headText} <br /> {t('Login.PARTS & ACCESSORIES')}</h1>
                            </Col>
                        </Row>

                        <Row>
                            {!login ?
                            <>
                                <Col sm={12}>
                                    <h3>{t('Login.DEALERS')}</h3>
                                    <p>{t('Login.This website is accessible for authorized Dealers only.')}</p>
                                </Col>
                                <Col sm={12} className="text-center">
                                        {/*<Button variant="secondary" onClick={e => { navigate('/dealerhome?id=41ad50c3f26543b29dc7') }}>*/}
                                        <Button variant="secondary" onClick={BackToKdealerLogin}>
                                        <svg xmlns="https://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-caret-right-fill green" viewBox="0 0 16 16" role="presentation">
                                            <path d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z" />
                                        </svg>
                                        {t('Login.LOGIN')}
                                    </Button>
                                </Col>
                            </>
                            :
                            <>
                                <Col>
                                    <h3>{t('Login.DEALERS')}</h3>
                                </Col>
                                <Col className="text-right">
                                    <p className="underline" onClick={ e => {setLogin(false)} }>{t('Login.Dealers Login')}</p>
                                </Col>
                            </>
                            }
                        </Row>

                        <Row className="gray-bg">
                            <Col sm={12}>
                                <h3>{t('Login.OTHER USERS')}</h3>
                                {!login ? 
                                    <p>{t('Login.For all other users')} <span className="underline" onClick={ e => {setLogin(true)} }>{t('Login.click here')}</span> {t('Login.to login or request access to the site.')}</p>
                                :
                                <>
                                    <p>{t('Login.Required Fields')}*</p>

                                    <form onSubmit={handleSignin}>
                                        <FloatingLabel controlId="floatingEmail" label={t("Login.Email Address") + "*"} className="mb-3">
                                            <Form.Control type="text" placeholder="name@example.com" onChange={handleChange} value={email} name="email" className={`form-control`} />
                                        </FloatingLabel>

                                        <FloatingLabel controlId="floatingPassword" label={t("Login.Password") + "*"} className="mb-3">
                                            <Form.Control type="password" placeholder={t("Login.Password")} onChange={handleChange} value={password} name="password" className={`form-control`} />
                                        </FloatingLabel>
                                            {LoginError}
                                        <div className="text-right m-t-md">
                                            <Button type="submit" variant="secondary">
                                                <svg xmlns="https://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-caret-right-fill green" viewBox="0 0 16 16" role="presentation">
                                                    <path d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z" />
                                                </svg>
                                                {t('Login.SIGN IN')}
                                            </Button>

                                            <p className="m-t-sm underline">{t('Login.Forgot Password')}</p>
                                        </div>
                                    </form>

                                </>
                                }

                            </Col>
                        </Row>
                    </Col>
                </Row>
            </Container>

            <FooterSmall />

            <Modal show={popUpModal} onHide={handlePopUpModalClose} dialogClassName="dealer-section" centered backdrop="static" keyboard={false}>
                <Modal.Header>
                    <Modal.Title>NOTICE</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Row>
                        <Col sm={12}>
                            <p>
                                Your login ID is associated with {!kDeal ? 'a Domestic' : 'an International'} Distributor/Dealer. You are being redirected to the {!kDeal ? 'K-Dealer' : 'K-Countries'} website.
                                Same Username and Password can be used for access to {!kDeal ? 'K-Dealer' : 'K-Countries'}.
                            </p>
                        </Col>
                    </Row>
                </Modal.Body>
                <Modal.Footer>
                    <Row>
                        <Col sm={12} className="text-center">
                            <Button variant="primary" onClick={() => LogoutDealerClick()}>
                                <svg xmlns="https://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-caret-right-fill" viewBox="0 0 16 16" role="presentation">
                                    <path d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z" />
                                </svg>
                                CONTINUE
                            </Button>
                        </Col>
                    </Row>
                </Modal.Footer>
            </Modal>
        </>
    );
}